import { Skeleton, Stack } from "@mui/material";
import React from "react";

const RectangleSkeletons = ({
  height = 67,
  totalRows = 3,
  gap = "8px",
  width = "100%",
  marginBottom,
  component = "div",
  alignItems = "flex-start",
}) => {
  const skeletons = [];

  for (let i = 0; i < totalRows; i++) {
    skeletons.push(
      <Skeleton
        key={i}
        variant="rounded"
        animation="wave"
        width={width}
        height={height}
        sx={{
          marginBottom: marginBottom && marginBottom,
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        }}
      />
    );
  }

  return (
    <Stack
      gap={gap}
      width="100%"
      component={component}
      flex="1"
      alignItems={alignItems}
    >
      {skeletons}
    </Stack>
  );
};

export default RectangleSkeletons;
